import {
  Auth0Provider as Provider,
  Auth0ProviderOptions,
} from '@auth0/auth0-react'

const isBrowser = typeof document !== 'undefined'

export const Auth0Provider = ({
  children,
  ...restProps
}: Auth0ProviderOptions): JSX.Element =>
  isBrowser ? (
    <>
      <Provider {...restProps}>{children}</Provider>
    </>
  ) : (
    <>{children}</>
  )
